import { render } from "./Value2Section.vue?vue&type=template&id=e889f55c&scoped=true"
import script from "./Value2Section.vue?vue&type=script&lang=js"
export * from "./Value2Section.vue?vue&type=script&lang=js"

import "./Value2Section.vue?vue&type=style&index=0&id=e889f55c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e889f55c"]])

export default __exports__